<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Signature Status</p>
    </header>
    <section class="modal-card-body">

      <div class="content full-width">
        <p class="between-center">
          <strong>Signed by Contact:</strong>
          <span class="has-text-right">{{ signatureInfo && signatureInfo.signed_by_client ? 'Yes' : 'No' }}</span>
        </p>
        <p class="between-center">
          <strong>Signed by Manager:</strong>
          <span class="has-text-right">{{ signatureInfo && signatureInfo.signed_by_manager ? 'Yes' : 'No' }}</span>
        </p>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.$parent.close()">Close</button>
    </footer>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    referenceId: {
      type: Number
    },
    referenceType: {
      type: String
    },
  },
  mounted() {
    axios.get(`/api/signature_info/${this.referenceType}/${this.referenceId}`)
        .then(response => {
          this.signatureInfo = response.data.data
        });
  },

  data () {
    return {
      signatureInfo: [

      ],
      checkedRows: [],
      selected: {},
      isBordered: false,
      isStriped: true,
      isNarrowed: false,
      isPaginated: false,
    }
  },
}
</script>
